import { createKubbApiClient } from '../kubb-api-client';
export * from '../kubb-api-client';

export const axiosClient = createKubbApiClient('social-export');

export default axiosClient;
